module.exports = __webpack_public_path__ + "static/img/icon-map.8aacb7d2.png";